import { useNavigate } from "react-router-dom";
import { useBilling } from "@/components/BillingProvider";
import { Button } from "@/components/ui/button";
import { Lock, Sparkles } from "lucide-react";

export default function Paywall() {
  const { billing } = useBilling();
  const navigate = useNavigate();

  if (!billing || billing.has_access) return null;

  return (
    <div
      className="fixed inset-0 z-[60] grid place-items-center bg-slate-950/60 backdrop-blur-sm p-4"
      data-testid="paywall-overlay"
    >
      <div className="glass-panel rounded-3xl max-w-md w-full p-8 shadow-2xl text-center">
        <div className="h-14 w-14 rounded-2xl bg-gradient-to-br from-blue-500 to-sky-500 grid place-items-center mx-auto shadow-lg shadow-blue-500/30">
          <Lock className="h-7 w-7 text-white" />
        </div>
        <h2 className="font-display text-2xl font-semibold mt-5">Tu período de prueba terminó</h2>
        <p className="text-sm text-muted-foreground mt-2">
          Suscríbete para seguir creando, editando y moviendo tus tarjetas.
          Tus boards siguen aquí esperándote.
        </p>
        <Button
          onClick={() => navigate("/pricing")}
          data-testid="paywall-upgrade"
          className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white"
        >
          <Sparkles className="h-4 w-4 mr-2" /> Ver planes
        </Button>
      </div>
    </div>
  );
}
